import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Products from "@/components/Products";
import ExperienceCompare from "@/components/ExperienceCompare";
import Process from "@/components/Process";
import EbookBanner from "@/components/EbookBanner";
import About from "@/components/About";
import Legacy from "@/components/Legacy";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { WEBSITE_JSONLD } from "@/lib/seo";

export default function Home() {
  return (
    <div className="relative">
      <SEO
        title="Crowned Canvas Creations | Custom Portrait & Canvas Art"
        description="Transform meaningful photographs, milestones and personal stories into custom artwork with Crowned Canvas Creations in Madison, Wisconsin. Explore Royal Essence, Sovereign Canvas and Majestic Vibes."
        path="/"
        jsonLd={[WEBSITE_JSONLD]}
      />
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <section id="experiences" className="scroll-mt-20"><Products /></section>
        <ExperienceCompare />
        <Process />
        <EbookBanner />
        <About />
        <Legacy />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
